/**
 * @file: 单选规则
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';

const rules: Array<($target: JQuery<EventTarget>, $cubeDom: JQuery<EventTarget>) => string> = [];

// 查询被命中的cube
export function queryCubeIdBeHit($target: JQuery<EventTarget>): string {
    let $cubeDom: JQuery<EventTarget> = $target.closest('[data-instanceid]');

    for (let i: number = 0; i < rules.length; i++) {
        let cubeId: string = rules[i]($target, $cubeDom);

        if (cubeId) {
            return cubeId;
        }
    }

    return '';
}

function addRule(rule): void {
    rules.push(rule);
}

// 商品命中规则
addRule(($target: JQuery<EventTarget>, $cubeDom: JQuery<EventTarget>): string => {
    let targetCubeId: string = $cubeDom.attr('data-instanceid');

    if (CubeTree.isGoods(targetCubeId)) {
        return targetCubeId;
    }

    return '';
});

// 文本框命中规则
addRule(($target: JQuery<EventTarget>, $cubeDom: JQuery<EventTarget>): string => {
    let targetCubeId: string = $cubeDom.attr('data-instanceid');

    if (CubeTree.isTextarea(targetCubeId)) {
        return targetCubeId;
    }

    return '';
});

// 隔板命中规则
addRule(($target: JQuery<EventTarget>, $cubeDom: JQuery<EventTarget>): string => {
    let targetCubeId: string = $cubeDom.attr('data-instanceid');

    if (CubeTree.isBafflePlate(targetCubeId)) {
        return targetCubeId;
    }

    return '';
});

// 层板命中规则
addRule(($target: JQuery<EventTarget>, $cubeDom: JQuery<EventTarget>): string => {
    let targetCubeId: string = $cubeDom.attr('data-instanceid');

    if (CubeTree.isCabinet(targetCubeId)) {
        return CubeTree.findParentIdByCubeId(targetCubeId);
    }

    if (CubeTree.isPartition(targetCubeId)) {
        return targetCubeId;
    }

    return '';
});

// 货架命中规则
addRule(($target: JQuery<EventTarget>, $cubeDom: JQuery<EventTarget>): string => {
    let targetCubeId: string = $cubeDom.attr('data-instanceid');

    if (CubeTree.isShelf(targetCubeId)) {
        return targetCubeId;
    }

    return '';
});

// 卧柜命中规则
addRule(($target: JQuery<EventTarget>, $cubeDom: JQuery<EventTarget>): string => {
    let targetCubeId: string = $cubeDom.attr('data-instanceid');

    if (CubeTree.isFreezer(targetCubeId)) {
        return targetCubeId;
    }

    return '';
});
